import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import VueLazyload from 'vue-lazyload';

Vue.use(VueCompositionAPI);

export default class App {
    config: any;

    constructor(config) {
        this.config = config;
    }

    bootstrap() {
        if (EASY_ENV_IS_NODE) {
            return this.server();
        }
        return this.client();
    }

    create(initState) {
        const { entry, createStore } = this.config;
        const store = createStore(initState);
        return {
            store,
            render: h => {
                return h(entry);
            },
        };
    }

    client() {
        // sw导致fmp上升5%，暂时下掉
        // require('@client/registerServiceWorker');
        const vm = this.create(window.__INITIAL_STATE__);

        Vue.use(VueLazyload, {
            preLoad: 1.1,
        });
        const app = new Vue(vm);
        app.$mount('#app');
        return app;
    }

    server() {
        return context => {
            const vm = this.create(context.state);
            const { store } = vm;
            context.state = store.state;
            return new Vue(vm);
        };
    }
}
